<template>
    <div class="suppliersContainer">
        <div class="pageHeader">
          <div class="pageTitle">
            <span class="pageTitleText">דף ההוצאות</span>
          </div>
          <div class="topLine">
            <ul>
              <li :class="[yesterdayItemNav == true ? 'activeItem' : '']"><a href="#" @click="yesterdayOrders()">אתמול</a></li>
              <li :class="[todayItemNav == true ? 'activeItem' : '']"><a href="#" @click="todayOrders()">היום</a></li>
              <li :class="[tommorowItemNav == true ? 'activeItem' : '']"><a href="#" @click="tommorowOrders()">מחר</a></li>
            </ul>
          </div>
        </div>
                <div class="suppliers">
                    <div class="header">
                        <div class="icon">
                            <i class="material-icons">credit_score</i>
                        </div>
                        <span class="text">רשימת השיקים</span>
                        <!-- <span class="text" @click="updateAll()">סמן הכל כנמשך</span> -->
                        <div class="searchDiv">
                            <input type="text" placeholder="חיפוש שיקים">
                        </div>
                    </div>
                    <table>
                        <tr>
                            <th></th>
                            <th>שם הספק \ החברה</th>
                            <th>סכום</th>
                            <th>ת"פ</th>
                            <th>תאריך ההוספה למערכת</th>
                            <th>הערה</th>
                            <th>מסמכים</th>
                            <th>כלים</th>
                        </tr>
                        <tr v-for="(expense, index) in $root.Expenses" :key="index" :id="expense.ID">
                            <td>
                                
                                <!-- <input type="checkbox" :checked="cheque.Data.checked" @change="checkLine(cheque.ID)" /> -->
                                <div class="checkboxes__item">
                                    <label class="checkbox style-c">
                                        <input type="checkbox" :checked="expense.checked"  @change="checkLine(expense.ID)" />
                                        <div class="checkbox__checkmark"></div>
                                    </label>
                                </div>
                            
                            </td>
                            <td>{{ expense.dealerName }}</td>
                            <td>₪{{ expense.amount }}</td>
                            <td>{{ expense.date }}</td>
                            <td>{{ expense.createdDate }}</td>
                            <td>{{ expense.note }}</td>
                            <td><span>צפייה במסמך</span></td>
                            <td><button @click="deleteDealer(expense)">X</button></td>
                            

                        </tr>
                        <tr>
                            <td></td>
                            <td>סך הכל</td>
                            <td>₪{{ $root.totalExpenses }}</td>
                        </tr>       
                    </table>
                </div>
    </div>
</template>
<script>
import { db } from '../firebase';
import firebase from "firebase/app";
import moment from 'moment';
import "firebase/storage"
import he from 'moment/locale/he'
export default {
  name: 'expenses',
  data () {
    return {
        Cheques:[],
        totalAmount:0,
        cheque:{
        dealerName:'',
        amount:0,
        date:'',
        createdDate: moment().format('LLLL'),
        checked: false,
      },
      chequeModal:false,
      errorDealer:null,
      todayItemNav:'',
      tommorowItemNav:'',
      yesterdayItemNav:''

    }
  },
  created(){
    let vm = this;
    if(vm.$root.loggedUser.Type !== 'Admin'){
        alert("אין לך גישה לדף הזה");
        vm.$router.go(-1);
    }
    vm.$root.loadExpenses();
  },

  methods:{
    addCheque(){
          let vm = this;
          console.log("Add ( chequeResult ) ");
          if (vm.cheque.dealerName.length > 0 && vm.cheque.date.length > 0  ){
            let cheque = {
                dealerName: vm.cheque.dealerName,
                amount:vm.cheque.amount,
                date:vm.cheque.date,
                createdDate: moment().format('LLLL'),
                checked: false,
            }
          db.collection("cheques").add(cheque)
              .then(function(chequeResult){   
                  console.log("Add ( chequeResult ) Success");
                  console.log(chequeResult);
                  vm.cheque.dealerName = "";
                  vm.cheque.amount = null;
                  vm.cheque.date = "";
              })
              .catch(function(error){
                  console.error('add( chequeResult ) Error !');
                  console.error(error);
              });
              }
              else if(vm.cheque.dealerName.length <= 0 && vm.cheque.date.length <= 0){
                vm.errorDealer = true;
                vm.errorAddingDealer = "נא למלא את השדה"
              }
      
            },
      deleteDealer(cheque){
        let vm = this;
          
          let answer = confirm("האם אתה בטוח למחוק הספק?" );
          
          if (answer){
            db.collection("cheques").doc(cheque.ID).delete().then(() => {
                vm.$root.loadChequesSum();
                console.log("Document successfully deleted!");
            }).catch((error) => {
                console.error("Error removing document: ", error);
            });

          }
      },
      checkLine(expenseId){
        console.log('checkLine(' + expenseId + ')');
            let vm = this;
            let isDone = true;
            for (let i = 0; i < vm.$root.Expenses.length; i++) {
                if (vm.$root.Expenses[i].ID === expenseId) {
                    if (vm.$root.Expenses[i].checked && vm.$root.Expenses[i].checked === true) {
                        isDone = false;
                    }
                    break;
                }
            }
            db.collection("Expenses").doc(expenseId).update({ checked: isDone })
            .then(function() {
                console.log("Document successfully updated!");
            }).catch((error) => {
                console.error("Error updating document: ", error);
            });
      },
      openChequeModal(){
        let vm = this;
        if (!vm.chequeModal) {
            vm.chequeModal = true;
		} else {
			vm.chequeModal = false;
		}
    },
    closeChequeModal(){
        let vm = this;
        if (vm.chequeModal) {
            vm.chequeModal = false;
		} else {
			vm.chequeModal = true;
		}
    },
    todayOrders(){
        let vm = this;
        vm.todayItemNav = true;
        vm.tommorowItemNav = false;
        vm.yesterdayItemNav = false;
        vm.fromDate = moment().format("YYYY-MM-DD");
        vm.toDate = moment().format("YYYY-MM-DD");
        
        vm.loadCheques()
      },
      tommorowOrders(){
        let vm = this;
        vm.tommorowItemNav = true;
        vm.todayItemNav = false;
        vm.yesterdayItemNav = false;
        vm.fromDate = moment().add(1, 'days').format("YYYY-MM-DD");
        vm.toDate = moment().add(1, 'days').format("YYYY-MM-DD");
        
        vm.loadCheques()
      },
      thisMonth(){
        let vm = this;
        vm.tommorowItemNav = false;
        vm.todayItemNav = false;
        vm.yesterdayItemNav = false;
        vm.fromDate = moment().startOf('month').format("YYYY-MM-DD");
        vm.toDate = moment().endOf('month').format("YYYY-MM-DD");
        
        vm.loadCheques()
      },
      lastMonth(){
        let vm = this;
        vm.tommorowItemNav = false;
        vm.todayItemNav = false;
        vm.yesterdayItemNav = false;
        vm.fromDate = moment().subtract("1","months").startOf('month').format("YYYY-MM-DD");
        vm.toDate = moment().subtract("1","months").endOf('month').format("YYYY-MM-DD");
        
        vm.loadCheques()
      },
      yesterdayOrders(){
        let vm = this;
        vm.yesterdayItemNav = true;
        vm.todayItemNav = false;
        vm.tommorowItemNav = false;
        vm.fromDate = moment().subtract(1, 'days').format("YYYY-MM-DD");
        vm.toDate = moment().subtract(1, 'days').format("YYYY-MM-DD");
        
        vm.loadCheques()
      },
//     updateAll(){
//         let vm = this;
//         db.collection("cheques").get().then((querySnapshot) => {
//         querySnapshot.forEach((doc) => {
//             doc.ref.update({checked: true})
//         })

// })

// }

}
}

</script>
<style>
.suppliersContainer{
    padding: 0 1rem;
    height: 100%;

}
.pageHeader{
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.pageTitle{
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
  margin-bottom: 10px;
}
.pageTitle .pageTitleText ,
.pageTitle .pageOrdersCounterText{
  color: #141c29;
  font-family: 'Noto Sans Hebrew';
}
.pageTitle .pageTitleText{
  font-size: 24px;
  font-weight: bold;
}
.pageTitle .pageOrdersCounterText{
  font-size: 14px;
  font-weight: 400;
  position: absolute;
  left: 0rem;
}
.topLine{
  border: 1px solid #f4f5f8;
  border-radius: 5px;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  height: 40px;
  overflow: hidden;
}
.topLine ul{
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  position: relative;
}
.topLine ul li{
  list-style: none;
  /* display: inline-block; */
  padding: 0 10px;
  cursor: pointer;
}
.topLine ul li a{
  text-decoration: none;
  font-size: 14px;
  color: #141c29;
}
.activeItem{
  background-color: #f4f5f8;
  color: #141c29;
  list-style: none;
  display: inline-block;
  padding: 0 10px;
  line-height: 40px;
  border-radius: 5px;
}
.modal-GR{
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    min-height: 100%;
    position: fixed;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-GR .modal-box{
    min-width: 450px;
    min-height: 300px;
    background-color: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 5px -3px rgba(255,255,255,0.2), 0 8px 10px 1px rgba(255,255,255,0.14), 0 3px 14px 2px rgba(255,255,255,0.12);
}
.modal-GR .modal-box .modal-header{
    padding: 1rem;
    border-bottom: 1px solid #e0e0e0;
    background-color: #fff;
    font-size: 16px;
    font-weight: 700;
    font-family: 'Noto Sans Hebrew';
    color: #000;
    display: flex;
    align-items: center;
}
.card {
	margin: 2rem auto;
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 425px;
	background-color: #FFF;
	border-radius: 10px;
	box-shadow: 0 10px 20px 0 rgba(#999, .25);
	padding: .75rem;
}

.card-image {
	border-radius: 8px;
	overflow: hidden;
	padding-bottom: 65%;
	background-image: url('https://assets.codepen.io/285131/coffee_1.jpg');
	background-repeat: no-repeat;
	background-size: 150%;
	background-position: 0 5%;
	position: relative;
}

.card-heading {
	position: absolute;
	left: 10%;
	top: 15%;
	right: 10%;
	font-size: 1.75rem;
	font-weight: 700;
	color: #735400;
	line-height: 1.222;
}

.card-form {
	padding: 2rem 1rem 0;
}
.error{
    margin: 1rem 0 0 0;
    color: red;
    background-color: #f4f5f8;
    border-right: 4px solid red;
    padding: 0.5rem 1rem;
}
.input {
	display: flex;
	flex-direction: column-reverse;
	position: relative;
	padding-top: 1.5rem;
}

.input-label {
	color: #8597a3;
	position: absolute;
	top: 1.5rem;
	transition: .25s ease;
}

.input-field {
    z-index: 1;
    background-color: transparent;
    border: 1px solid #eee;
    font: inherit;
    padding: 0.5rem 1rem;
    font-family: 'Noto Sans Hebrew';
}

.action {
    margin-top: 2rem;
    background-color: #141c29;
    text-align: center;
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    font-family: 'Noto Sans Hebrew';
}

/* .action-button {
	font: inherit;
	font-size: 1.25rem;
	padding: 1em;
	width: 100%;
	font-weight: 500;
	background-color: #6658d3;
	border-radius: 6px;
	color: #FFF;
	border: 0;
} */

.card-info {
	padding: 1rem 1rem;
	text-align: center;
	font-size: .875rem;
	color: #8597a3;

}
.suppliers{
    width:100% ;
    min-height: 50px;
    background-color: #fff;
    border: #e0e0e0 1px solid;
    border-radius: 8px;
    overflow: hidden;
}
.suppliers .header
{
    width: 100%;
    /* height: 60px; */
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    padding: 1rem;
    position: relative;
}

.suppliers .header .icon
{
    padding: 0.5rem;
    border: 1px solid #e0e0e0;
    width:40px;
    height: 40px;
    text-align: center;
    border-radius: 8px;
    background-color: #fff;
}

.suppliers .header .icon i{
    font-size: 20px;
    color: #1c1c1c;
}

.suppliers .header .text{
    font-size: 14px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
    color: #707070;
    margin-right: 10px;
}
.suppliers .header .searchDiv
{
    position: absolute;
    left: 1rem;
}
.suppliers .header .searchDiv input{
    width: 280px;
    border-radius: 8px;
    border:1px solid #e0e0e0;
    padding: 0.3rem 1rem;
    font-size: 13px;
    font-weight: 400;
    color: #707070;
    background-color: #f5f5f5;
    font-family: 'Noto Sans Hebrew';

}

table {
  border-collapse: collapse;
  width: 100%;
}
th{
    color: #1c1c1c;
}
th, td {
  padding: 8px;
  text-align: right;
  border-bottom: 1px solid #ddd;
  font-family: 'Noto Sans Hebrew';
  font-size: 13px;
}
td{
    font-size:15px;
    color:#141c29;
    font-weight:500;
}
td button {
    padding: 5px 14px;
    border-radius: 8px;
    border: 0;
    background-color: #d11a2a;
    color: #fff;

}
/* STYLE C */
.checkboxes__item{
    display: flex;
    justify-content: center;
    align-items: center;
}
.checkbox.style-c {
  display: inline-block;
  position: relative;
  padding-left: 0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.checkbox.style-c input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkbox.style-c input:checked ~ .checkbox__checkmark {
  background-color: #f7cb15;
}
.checkbox.style-c input:checked ~ .checkbox__checkmark:after {
  opacity: 1;
}
.checkbox.style-c:hover input ~ .checkbox__checkmark {
  background-color: #eee;
}
.checkbox.style-c:hover input:checked ~ .checkbox__checkmark {
  background-color: #f7cb15;
}
.checkbox.style-c .checkbox__checkmark {
  height: 20px;
  width: 20px;
  background-color: #eee;
  transition: background-color 0.25s ease;
  border-radius: 4px;
}
.checkbox.style-c .checkbox__checkmark:after {
  content: "";
  position: absolute;
  left: 8px;
  top: 4px;
  width: 5px;
  height: 10px;
  border: solid #333;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  opacity: 0;
  transition: opacity 0.25s ease;
}
.checkbox.style-c .checkbox__body {
  color: #333;
  line-height: 1.4;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/pages/expenses.vue